module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ng-image__2-8a19edd2c1498db11e05d713a93b04c8.png";